'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getParents = getParents;
var _isElement = require('./isElement');

/**
 * Returns all the element and all of its parents
 * @param { DOM Element }
 * @return { Array of DOM elements }
 */
function getParents(el) {
  var parents = [];
  var currentElement = el;
  while ((0, _isElement.isElement)(currentElement)) {
    parents.push(currentElement);
    currentElement = currentElement.parentNode;
  }
  return parents;
}